import { render } from "./ManagePracticesModal.vue?vue&type=template&id=83700c8a&scoped=true"
import script from "./ManagePracticesModal.vue?vue&type=script&lang=js"
export * from "./ManagePracticesModal.vue?vue&type=script&lang=js"

import "./ManagePracticesModal.vue?vue&type=style&index=0&id=83700c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83700c8a"]])

export default __exports__